import { IKeyValuePair } from './interfaces';

export default [
    { key: null, value: 'All' } as IKeyValuePair,
    { key: 0, value: 'Parking Trip' },
    { key: 1, value: 'Replenishment' },
    { key: 2, value: 'Manual Adjustment' },
    { key: 3, value: 'Year-End Adjustment' },
    { key: 4, value: 'Annual Minimum Usage Fee Adjustment' }
] as Array<IKeyValuePair>;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/data/transaction-types.ts